module.exports = __webpack_public_path__ + "static/media/SourceSansPro-SemiboldIt.b270e248.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SourceSansPro-SemiboldIt.svg
// module id = 347
// module chunks = 3